
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    export class PsMeberStatusGrid extends Serenity.EntityGrid<PsMeberStatusRow, any> {
        protected getColumnsKey() { return PsMeberStatusColumns.columnsKey; }
        protected getDialogType() { return PsMeberStatusDialog; }
        protected getIdProperty() { return PsMeberStatusRow.idProperty; }
        protected getInsertPermission() { return PsMeberStatusRow.insertPermission; }
        protected getLocalTextPrefix() { return PsMeberStatusRow.localTextPrefix; }
        protected getService() { return PsMeberStatusService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}